export const TaskActions = {
    GetTaskLists: 'GetTaskLists',
    TaskLists: 'TaskLists',
    SubscribeTaskList: 'SubscribeTaskList',
    IsTaskListsLoading: 'IsTaskListsLoading',
    IsSubscribeLoading: 'IsSubscribeLoading',
};